/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Modal, ModalProps } from '@blend/consumer-components';
import { css } from 'aphrodite';
import { getStyleConfig, styles } from '../Modals/styles';
import { useRootSelector } from '../../../hooks/useRootSelector';
import { ActionButton } from '@components/ActionButton/ActionButton';

export namespace SigningModal {
  export interface OwnProps extends ModalProps {
    signerName: string;
    documentName: string;
    onSubmit: () => void;
  }
  export type Props = OwnProps;
}

export const SigningModal: React.FC<SigningModal.Props> = ({ ...props }) => {
  const isMobileView = useRootSelector(state => state.layout.isMobileView);
  return (
    <Modal styleConfig={getStyleConfig(isMobileView)} {...props}>
      <div className={css(styles.content)}>
        <div className={css(styles.heading)}>{props.signerName}, it's your turn</div>
        <div className={css(styles.description)}>
          You can now start signing <strong>{props.documentName}</strong>
        </div>
        <div className={css(styles.primaryButton)} onClick={props.onSubmit}>
          <ActionButton data-dd-privacy="allow">Start signing</ActionButton>
        </div>
      </div>
    </Modal>
  );
};
